<div mat-dialog-title class="modal-title">
  <mat-icon>shopping_cart</mat-icon>
  <span>Confirma las compras</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <p>
    Vas a adquirir un producto de pago único y uno de pago recurrente al mismo tiempo. Debes aprobar el pago de cada uno por separado, haciendo clic
    en la URL respectiva:
  </p>
  @if (links) {
    <div class="links">
      <span>
        <a [href]="links.uniqueApprovalLink" target="_blank"> URL de pago único </a>
      </span>
      <span>
        <a [href]="links.subscriptionApprovalLink" target="_blank"> URL de pago recurrente </a>
      </span>
    </div>
  }
</mat-dialog-content>
